<form novalidate (ngSubmit)="save()" #formClientInfo="ngForm">
    <div class="card-body mt-0 pt-4">
        <div class="row align-items-center">
            <div class="flex-shrink-0 ml-3">
                <div class="symbol symbol-50 symbol-lg-100"> 
                    <!-- src="./../../../../assets/images/landscape-placeholder.svg"  -->
                    <img 
                        [src]="clientImage" 
                        alt="Client Photo" 
                        (error)="onImageError($event)" 
                        (click)="openCameraModal()"
                        class="img-thumbnail img-fluid" 
                        loading="lazy"
                        style="object-fit: cover; aspect-ratio: 1/1; width: 100px; height: 100px;" 
                    />
                </div>
            </div>

            <div class="col-lg-2 mb-lg-0 mb-4 form-group">
                <label>
                    Client #.:
                </label>
                <input type="text" class="form-control" name="_client_no" autocomplete="off" disabled
                    [(ngModel)]="clientService.client.client_no" />
            </div>

            <div class="col-lg-3 mb-lg-0 mb-4 form-group required">
                <label>
                    First Name:
                </label>
                <!-- <input type="text" class="form-control" name="_client_first_name" autocomplete="off"
                    [(ngModel)]="clientService.client.first_name" required /> -->
                <div class="d-flex align-items-center">
                    <input type="text" class="form-control form-control mr-2" name="_client_first_name" required
                        autocomplete="off" [(ngModel)]="clientService.client.first_name">
                    <button type="button" class="btn btn-outline-secondary" (click)="clinicService.openPersonModal('setup-client')">
                        <i class="las la-male p-0"></i>
                    </button>
                </div>
            </div>

            <div class="col-lg-3 mb-lg-0 mb-4 form-group required">
                <label>
                    Last Name:
                </label>
                <input type="text" class="form-control" name="_client_last_name" autocomplete="off"
                    [(ngModel)]="clientService.client.last_name" required />
            </div>

            <div class="col-lg-2 mb-lg-0 mb-4 form-group">
                <label>
                    Middle Initial:
                </label>
                <input type="text" class="form-control" name="_client_middle_initial" autocomplete="off"
                    [(ngModel)]="clientService.client.middle_initial" maxlength="1" />

            </div>
        </div>
        <div class="row">
             
            <div class="col-lg-12 my-3 separator separator-dashed"></div>
        </div>
        <!-- added by hry -->
        <div class="row">
            <div class="col-lg-5 mb-lg-0 mb-2 form-group required">
                <label>
                    Email Address:
                </label>
                <input type="email" class="form-control" name="_email" autocomplete="off"
                    [(ngModel)]="clientService.client.email_address" />
            </div>

            <div class="col-lg-3 mb-lg-0 mb-4 form-group required">
                <label>
                    Phone Number:
                </label>
                <input type="text" class="form-control" name="_home_phone" autocomplete="off"
                    [(ngModel)]="clientService.client.home_phone" placeholder="000-000-0000" required />
            </div>

            <div class="col-lg-2 mb-lg-0 mb-4 form-group required">
                <label>Status:</label>
                <select class="form-control" name="_active" required
                    [(ngModel)]="clientService.client.active">
                    <option value=""></option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                </select>
            </div>

            <div class="col-lg-2 mb-lg-0 mb-4 form-group required">
                <label>Type:</label>
                <select class="form-control" name="_type" required
                    [(ngModel)]="clientService.client.nonprofit">
<<<<<<< HEAD
                    <option [ngValue]="false">For-Profit</option>
                    <option [ngValue]="true">Nonprofit</option>
=======
                    <option value="false">Profit</option>
                    <option value="true">Non-Profit</option>
>>>>>>> 6bce9cac922e8a15532e89c8a0ede630125b9af5
                </select>
            </div>

            <div class="col-lg-12 my-3 separator separator-dashed"></div>
        </div>

        <div class="row">
            <div class="col-lg-3 mb-lg-0 mb-4 form-group">
                <label>Codes:</label>
                <div class="input-group">
                    <input type="text" class="form-control" name="_client_code" cursor="pointer" autocomplete="off"
                        [(ngModel)]="clientService.client.client_code" disabled="true" (click)="codes()" />
                    <div class="input-group-append">
                        <button type="button" (click)="codes()" class="btn btn-icon btn-secondary">
                            <i class="la la-edit" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 mb-lg-0 mb-4 form-group">
                <label> Insurance info:</label>
                <input type="text" class="form-control" name="_insurante" autocomplete="off" />
            </div>
            <div class="col-lg-4 mb-lg-0 mb-4 form-group">
                <label> Client Source:</label>
                <div class="input-group">
                    <input type="text" class="form-control" name="_source" autocomplete="off"
                        [(ngModel)]="clientService.client.source" />
                    <div class="input-group-append">
                        <button type="button" (click)="source()" class="btn btn-icon btn-secondary">
                            <i class="la la-edit" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 my-3 separator separator-dashed"></div>
        </div>
        <div class="row mb-3">
            <div class="col-lg-8 mb-lg-0 mb-4 form-group required">
                <label>
                    Address:
                </label>
                <input type="text" class="form-control" name="_address" autocomplete="off" required
                    [(ngModel)]="clientService.client.address" />
            </div>
            <div class="col-lg-4 mb-lg-0 mb-4 form-group required">
                <label>
                    City:
                </label>
                <input type="text" class="form-control" name="_city" autocomplete="off" required
                    [(ngModel)]="clientService.client.city" />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3 mb-lg-0 mb-4 form-group required">
                <label>
                    State:
                </label>
                <input type="text" class="form-control" name="_state" autocomplete="off" required
                    [(ngModel)]="clientService.client.state" />
            </div>
            <div class="col-lg-2 mb-lg-0 mb-4 form-group required">
                <label>
                    Zip:
                </label>
                <input type="text" class="form-control" name="_zip" autocomplete="off"
                    [(ngModel)]="clientService.client.zip" (keydown)="searchz($event)" required>
                <div style="background-color: darkgray; position: absolute; z-index: 2; width: 15vw; left: 5%; -moz-border-radius:5px; -webkit-border-radius: 5px; border-radius: 5px; behavior: url(border-radius.htc);"
                    *ngIf="buscador_activo">
                    <div class="row text-center  badge-hand" style="color: #00000F; font-weight: bold; font-size: 14px;"
                        *ngFor="let item of suggestedzWordsArray; let i = index;" (click)="selectz(item)">
                        <div class="col-12 badge-hand">
                            <label class="badge-hand">
                                {{ item.zip_code }} - {{ item.city }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 mb-lg-0 mb-4 form-group">
                <label>
                    County:
                </label>
                <input type="text" class="form-control" name="_county" autocomplete="off"
                    [(ngModel)]="clientService.client.county" />
            </div>
            <div class="col-lg-4 mb-lg-0 mb-4 form-group">
                <label>
                    Country:
                </label>
                <input type="text" class="form-control" name="_country" autocomplete="off"
                    [(ngModel)]="clientService.client.country" />
            </div>
            <div class="col-lg-12 my-3 separator separator-dashed"></div>
        </div>
        <div class="row mb-3">
            <div class="col-lg-3 mb-lg-0 mb-4 form-group">
                <label>
                    Driver License:
                </label>
                <div class="input-group">
                    <input [type]="view_ld ? 'text' : 'password'" class="form-control" name="_driver_license"
                        autocomplete="off" [readonly]="view_ld ? null : 'disabled'"
                        [(ngModel)]="clientService.client.driver_license" />
                    <div class="input-group-append">
                        <button type="button" (click)="view('driver_license')" class="btn btn-icon btn-secondary">
                            <i class="la la-edit" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 mb-lg-0 mb-4 form-group">
                <label>
                    Credit Card:
                </label>
                <div class="input-group">
                    <input [type]="view_cc ? 'text' : 'password'" class="form-control" name="_credit_card"
                        autocomplete="off" [readonly]="view_ld ? null : 'disabled'"
                        [(ngModel)]="clientService.client.credit_card" />
                    <div class="input-group-append">
                        <button type="button" (click)="view('credit_card')" class="btn btn-icon btn-secondary">
                            <i class="la la-edit" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 mb-lg-0 mb-4 form-group">
                <label>
                    Gross Year to Date:
                </label>
                <input type="text" class="form-control" name="_year_to_date" autocomplete="off" disabled
                    [(ngModel)]="clientService.client.year_to_date" />

            </div>
            <div class="col-lg-3 mb-lg-0 mb-4 form-group">
                <label>
                    Over Due:
                </label>
                <input type="text" class="form-control" name="_over_due" autocomplete="off" />
            </div>
        </div>
    </div>
    <div class="card-footer text-right py-3"> 
        <button type="submit" class="btn btn-primary" [disabled]="formClientInfo.invalid">
            <i class="lar la-save"></i> Save
        </button>
    </div>
</form>

<!-- Modal -->
<div class="modal fade" id="modalNewClientCodes" tabindex="-1" role="dialog" aria-labelledby="modalNewClientCodes"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="modalNewPetNoteLabel">Client Codes</h5>
                <button type="button" class="close" aria-label="Close" (click)="close_codes()">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <form (ngSubmit)="add()" #formAddProc="ngForm"
                        style="display: inherit; width: -webkit-fill-available;">
                        <div class="col">
                            <div class="form-group">
                                <label>Add new code:</label>
                                <input type="text" autocomplete="off"
                                    class="form-control form-control-solid form-control form-control-solid-solid"
                                    required name="_code_name" [(ngModel)]="code.name" (keydown)="search($event)">
                                <div style="background-color: darkgray; position: absolute; z-index: 2; width: 40vw; left: 5%; -moz-border-radius:5px; -webkit-border-radius: 5px; border-radius: 5px; behavior: url(border-radius.htc);"
                                    *ngIf="buscador_activo">
                                    <div class="row text-center  badge-hand"
                                        style="color: #00000F; font-weight: bold; font-size: 14px;"
                                        *ngFor="let item of suggestedWordsArray; let i = index;" (click)="select(item)">
                                        <div class="col-12 badge-hand">
                                            <label class="badge-hand">
                                                {{ item.code }} - {{ item.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2" style="text-align: center;">
                            <button type="submit" class="btn btn-success" [disabled]="formAddProc.invalid">
                                Add
                            </button>
                        </div>
                    </form>
                </div>
                <div class="row" *ngFor="let item of lst_codes">
                    <div class="col-md-2">
                        {{ item.code }}
                    </div>
                    <div class="col">
                        {{ item.name }}
                    </div>
                    <div class="col-md-2">
                        <button type="button" class="btn btn-icon btn-secondary btn-sm btn-hover-danger m-1"
                            (click)="delete(item)">
                            <i class="la la-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!-- -->
                <!-- <button type="submit" class="btn font-weight-bold btn-primary">
                    Add New Code
                </button> -->
                <button type="button" class="btn font-weight-bold btn-secondary ml-3" (click)="close_codes()">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalNewClientSource" tabindex="-1" role="dialog" aria-labelledby="modalNewClientSource"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="modalNewPetNoteLabel">Client Source</h5>
                <button type="button" class="close" aria-label="Close" (click)="close_source()">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>How did you hear about our clinic?</label>
                            <input type="text" autocomplete="off"
                                class="form-control form-control-solid form-control form-control-solid-solid" required
                                name="_source" [(ngModel)]="clientService.client.source">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!-- -->
                <!-- <button type="submit" class="btn font-weight-bold btn-primary">
                    Add New Code
                </button> -->
                <button type="button" class="btn font-weight-bold btn-secondary ml-3" (click)="close_source()">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalNewClientCreditCard" tabindex="-1" role="dialog"
    aria-labelledby="modalNewClientCreditCard" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="modalNewPetNoteLabel">Credit Card</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Credit Card number</label>
                            <input type="text" autocomplete="off"
                                class="form-control form-control-solid form-control form-control-solid-solid" required
                                maxlength="20" name="_credit_card" [(ngModel)]="clientService.client.credit_card">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Credit Card type</label>
                            <input type="text" autocomplete="off"
                                class="form-control form-control-solid form-control form-control-solid-solid" required
                                maxlength="6" name="_credit_card_type"
                                [(ngModel)]="clientService.client.credit_card_type">
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>Enter expiration date</label>
                            <input type="text" autocomplete="off"
                                class="form-control form-control-solid form-control form-control-solid-solid" required
                                maxlength="10" name="_expiration_date"
                                [(ngModel)]="clientService.client.expiration_date">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!-- -->
                <!-- <button type="submit" class="btn font-weight-bold btn-primary">
                    Add New Code
                </button> -->
                <button type="button" class="btn font-weight-bold btn-secondary ml-3" (click)="view('credit_card')">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalNewClientDriveLicense" tabindex="-1" role="dialog"
    aria-labelledby="modalNewClientDriveLicense" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="modalNewPetNoteLabel">Driver's license</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Driver's license state</label>
                            <input type="text" autocomplete="off"
                                class="form-control form-control-solid form-control form-control-solid-solid" required
                                maxlength="6" name="_social_security"
                                [(ngModel)]="clientService.client.social_security">
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>First name of license</label>
                            <input type="text" autocomplete="off"
                                class="form-control form-control-solid form-control form-control-solid-solid" required
                                maxlength="10" name="_driver_license" [(ngModel)]="clientService.client.driver_license">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!-- -->
                <!-- <button type="submit" class="btn font-weight-bold btn-primary">
                    Add New Code
                </button> -->
                <button type="button" class="btn font-weight-bold btn-secondary ml-3" (click)="view('driver_license')">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>